import { CategoryDto } from 'booksprout'
import { categoryName } from './categoryName'

/**
 * `locale` is what the reader is seeing, so the alphabetical tie-break runs on the names actually
 * on screen. Without it a Spanish reader gets a list ordered by the English words, which looks
 * arbitrary. Callers on the untranslated apps leave it out and keep sorting by the English name.
 */
export function compareCategoriesByOrder (a: CategoryDto, b: CategoryDto, locale?: string): number {
  return (a.sortOrder ?? 0) - (b.sortOrder ?? 0) ||
    categoryName(a, locale).localeCompare(categoryName(b, locale), locale || void 0) ||
    a.id - b.id
}

export function sortCategoriesByOrder (categories: CategoryDto[], locale?: string): CategoryDto[] {
  return [...categories].sort((a, b) => compareCategoriesByOrder(a, b, locale))
}

export function sortCategoryTreeByOrder (categories: CategoryDto[], locale?: string): CategoryDto[] {
  return sortCategoriesByOrder(categories, locale).map(category => ({
    ...category,
    childCategories: category.childCategories
      ? sortCategoryTreeByOrder(category.childCategories, locale)
      : category.childCategories
  }))
}
